import Backbone from '@/backbone'

// DEPRECATED: `pe/backbone/mini-views/quota.js`, pending full removal with 8.48.
console.error('`pe/backbone/mini-views/quota.js` is deprecated, pending full removal with 8.48. Please use `pe/quota/quota.vue` instead')

const QuotaView = Backbone.View.extend({
  tagName: 'div',
  initialize () {
    console.error('`QuotaView` from `pe/backbone/mini-views/quota.js` is deprecated, pending full removal with 8.48.')
  },
  render () {
    return this
  }
})

export default QuotaView
